
export default {
    data() {
        return {
            nav: 0,
            source: '',
            currentPage: 1,
            sidebar: 'en'
        }
    },
    mounted() {
        this.parametricWork()
    },
    watch: {
        sidebar: {
            handler: function (val) {
                switch (val) {
                    case 'ru':
                        this.$i18n.locale = 'ru'
                        // this.$t('christmas.NAV_5') = this.arrlang.en
                        break;
                    case 'br':
                        this.$i18n.locale = 'br'
                        // this.$t('christmas.NAV_5') = this.arrlang.en
                        break;
                    case 'jp':
                        this.$i18n.locale = 'jp'
                        // this.$t('christmas.NAV_5') = this.arrlang.en
                        break;
                    case 'jp':
                        this.$i18n.locale = 'jp'
                        // this.$t('christmas.NAV_5') = this.arrlang.en
                        break;
                    case 'en':
                        this.$i18n.locale = 'en'
                        // this.$t('christmas.NAV_5') = this.arrlang.en
                        break;
                    case 'fr':
                        this.$i18n.locale = 'fr'
                        // this.$t('christmas.NAV_5') = this.arrlang.fr
                        break;
                    case 'es':
                        this.$i18n.locale = 'es'
                        // this.$t('christmas.NAV_5') = this.arrlang.es
                        break;
                    case 'pt':
                        this.$i18n.locale = 'pt'
                        // this.$t('christmas.NAV_5') = this.arrlang.pt
                        break;
                    case 'de':
                        this.$i18n.locale = 'de'
                        // this.$t('christmas.NAV_5') = this.arrlang.de
                        break;
                    case 'it':
                        this.$i18n.locale = 'it'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'kr':
                        this.$i18n.locale = 'kr'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'ru':
                        this.$i18n.locale = 'ru'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'yn':
                        this.$i18n.locale = 'yn'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'cz':
                        this.$i18n.locale = 'cz'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'ta':
                        this.$i18n.locale = 'ta'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'ar':
                        this.$i18n.locale = 'ar'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    case 'pl':
                        this.$i18n.locale = 'pl'
                        // this.$t('christmas.NAV_5') = this.arrlang.it
                        break;
                    default:
                        break;
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 作品方法
        async parametricWork(type, page = 1) {
            let res = await this.$global.parametricWork({ "activityId": 19, "page": page, "award": 0 })
            console.log(res);
            // res.code = '200' ? (this.source = res.result) : []
            this.source = res
        },
        // 分页
        handleCurrentChange(val) {
            this.currentPage = val
            this.parametricWork(28, this.currentPage)
        },
        changeLanguage(lang) {
            this.sidebar = lang
            this.$loadLanguageAsync(lang)
        }
    }
}
